import React from 'react';
import { SuccessCriteriaPanel } from './SuccessCriteriaPanel';
import { CommentBanksPanel } from './CommentBanksPanel';
import { RubricsPanel } from './RubricsPanel';
import { ShortAnswerPanel } from './ShortAnswerPanel';

export function Tiles({
  onExpandCommentBanks,
  onExpandSuccessCriteria,
  onExpandRubrics,
  onExpandShortAnswer,
}) {
  return (
    <div className="ci-panels-grid">
      <CommentBanksPanel
        mode="small"
        onExpand={onExpandCommentBanks}
      />
      <SuccessCriteriaPanel
        mode="small"
        onExpand={onExpandSuccessCriteria}
      />
      <RubricsPanel
        mode="small"
        onExpand={onExpandRubrics}
      />
      <ShortAnswerPanel
        mode="small"
        onExpand={onExpandShortAnswer}
      />
    </div>
  );
}
